module.exports = __webpack_public_path__ + "img/flags/ES.10d63db.png";